import { Base } from 'layouts'
import { ClientGroupList } from 'components'

import * as S from './styled'

export function ClientGroup() {
  return (
    <Base>
      <S.GridContainer container>
        <ClientGroupList />
      </S.GridContainer>
    </Base>
  )
}
